import React, { Component } from 'react';
import axios from 'axios';
import dateFormat from 'date-fns/format';
import Footer from './Footer';
import { colors } from '../theme';
import '../css/About.css';

class News extends Component {
  render() {
    return (
      <div className="staticParent">
        <div className="staticWidth">
          <div className="staticHeader">News & Analysis</div>
          <div className="staticBody">
            {this.state.posts.map((post, i) => (
              <div className="faded flex flex-justify" key={post.id}>
                <div className="teamBio">
                  <div style={{ fontWeight: 'bold' }}>{post.title}</div>
                  <div style={{ fontWeight: 'bold', paddingBottom: '10px' }}>
                    {dateFormat(post.date, 'DD MMM YYYY')}
                  </div>
                  <div>
                    <div dangerouslySetInnerHTML={{ __html: post.body }} />
                  </div>
                  {post.file_id && (
                    <a
                      href={
                        'https://res.cloudinary.com/gates/image/upload/' +
                        post.file_id
                      }
                      target="_blank"
                      style={{
                        color: colors.gold500,
                      }}
                    >
                      Download Article
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
          <Footer />
        </div>
      </div>
    );
  }

  constructor(props) {
    super();
    this.state = {
      posts: [],
    };
  }

  componentDidMount() {
    this.getPosts();
  }

  getPosts() {
    axios
      .get('/post')
      .then(result => {
        if (result.data.length) this.setState({ posts: result.data });
      })
      .catch(error => {
        console.log(error);
      });
  }
}

export default News;



// WEBPACK FOOTER //
// ./src/components/News.jsx